const storage = new Proxy(
  {},
  {
    get(target, prop) {
      if (prop in localStorage) {
        try {
          return JSON.parse(localStorage[prop])
        } catch (err) {
          return null
        }
      } else {
        return null
      }
    },
    set(target, prop, value) {
      localStorage[prop] = JSON.stringify(value)
      return true
    }
  }
)

function clear() {
  console.log('clear storage')
  localStorage.clear()
}

export { storage, clear }
